import { useFormContext } from "react-hook-form";
import { usersApiKeyStore } from "../../../api/users-api-key-store";
import { useLoadData } from "../../../hooks/useLoadData";
import { ApiResponse } from "../../../models/api-response";
import { useEffect, useState } from "react";
import { SiTrackGrid } from "../../../components/si-track-grid/si-track-grid";
import { roleGridColumns } from "./role-grid-columns";
import { UserPermissionName } from "../../../models/user-permission-name";

interface UserRoleComponent {
    userRoleCode: string;
    selectedUsers: any[];
    onChildLoading: (childLoading: boolean) => void;
    onSelectedUsers: (users: any[]) => void;
}
export const UserRoleComponent = ({ userRoleCode, selectedUsers, onChildLoading, onSelectedUsers }: UserRoleComponent) => {
    const { getValues } = useFormContext();
    const [completeData, setCompleteData] = useState();
    const [selectUser, setSelectUser] = useState<any[]>(selectedUsers ?? []);
    const { data, isLoading, isFetching, refetch } = useLoadData<ApiResponse<any>>(usersApiKeyStore.getUsersByRole(userRoleCode));

    useEffect(() => {
        if (data) {
            const updatedData = data?.data.map((d: any) => ({
                ...d,
                isSelected: selectUser?.some((s: any) => s.userID === d.userID && s.roleID === d.roleID),
            }));
            setCompleteData(updatedData);
        }
        if (userRoleCode) refetch();
    }, [data, userRoleCode]);

    useEffect(() => { onChildLoading(isLoading || isFetching) }, [isLoading, isFetching])

    const handleSelectedItem = (userData: any[]) => {
        const filteredArray = selectUser?.filter(item => item.roleID !== getValues("roleName")?.roleID);
        setSelectUser([...filteredArray, ...userData]);
        onSelectedUsers([...filteredArray, ...userData]);
    }

    return (
        <>
            <SiTrackGrid
                fileTitle='office_user'
                dataItems={completeData}
                columns={roleGridColumns}
                dataItemKey="userID"
                selectedField="isSelected"
                onSelectedItems={handleSelectedItem}
                actionPermissions={{
                    export: UserPermissionName.DOWNLOAD_GRID
                }}
                isBusy={isLoading || isFetching}
            />
        </>
    );
}